import TextLink from '@/components/TextLink';
import { UserFlow } from '@/types';
import { trackEvent } from '@/utils/analytics';

type Props = {
  readonly className?: string;
};

const PasswordSignInLink = ({ className }: Props) => {
  return (
    <TextLink
      replace
      className={className}
      // Icon={<SwitchIcon />}
      text="action.sign_in_via_password"
      to={`/${UserFlow.SignIn}/password`}
      onClick={() => {
        trackEvent(
          'password_sign_in_link',
          'clicked',
          { eventId: 'verification_code_password_sign_in_link_clicked' }
        );
      }}
    />
  );
};

export default PasswordSignInLink;
